"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _immutable = require("immutable");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactTransitionGroup = require("react-transition-group");

var _actions = require("composer-lib/redux/actions");

var _toast = _interopRequireDefault(require("composer-lib/components/alerts/toast"));

var initialMargin = 110;
var marginToTop = 20;

var mapStateToProps = function mapStateToProps(state) {
  return {
    toastData: state.toasts
  };
};

var mapDispatchToProps = {
  removeToast: _actions.removeToast
};
var ToastContainer = (0, _createReactClass.default)({
  displayName: "ToastContainer",
  propTypes: {
    removeToast: _propTypes.default.func.isRequired,
    toastData: _propTypes.default.instanceOf(_immutable.OrderedMap).isRequired
  },
  getInitialState: function getInitialState() {
    return {
      isPastDefaultMargin: false,
      yOffset: 0
    };
  },
  componentDidMount: function componentDidMount() {
    window.addEventListener('scroll', this.checkToastMargin);
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    var _this$state = this.state,
        isPastDefaultMargin = _this$state.isPastDefaultMargin,
        yOffset = _this$state.yOffset;
    return !(0, _immutable.is)(this.props.toastData, nextProps.toastData) || isPastDefaultMargin !== nextState.isPastDefaultMargin || yOffset !== nextState.yOffset;
  },
  componentWillUnmount: function componentWillUnmount() {
    window.removeEventListener('scroll', this.checkToastMargin);
  },
  checkToastMargin: function checkToastMargin() {
    var isPastDefaultMargin = this.state.isPastDefaultMargin;
    var _window = window,
        scrollY = _window.scrollY;
    var scrollDiff = initialMargin - marginToTop;

    if (scrollY > scrollDiff && !isPastDefaultMargin) {
      this.setState({
        isPastDefaultMargin: true,
        yOffset: initialMargin
      });
    }

    if (scrollY <= scrollDiff) {
      this.setState({
        isPastDefaultMargin: false,
        yOffset: scrollY
      });
    }
  },
  render: function render() {
    var _this = this;

    var toastData = this.props.toastData;
    var _this$state2 = this.state,
        isPastDefaultMargin = _this$state2.isPastDefaultMargin,
        yOffset = _this$state2.yOffset;
    var top = isPastDefaultMargin ? marginToTop : initialMargin - yOffset;

    if (toastData.isEmpty()) {
      return null;
    }

    return _react.default.createElement("div", {
      className: "toast-container p-x-10 align-center",
      style: {
        top: top
      }
    }, toastData.map(function (toast, key) {
      return _react.default.createElement(_reactTransitionGroup.CSSTransitionGroup, {
        className: "toasts",
        key: key,
        transitionAppear: true,
        transitionName: "toasts",
        transitionAppearTimeout: 500,
        transitionEnterTimeout: 500,
        transitionLeaveTimeout: 300
      }, _react.default.createElement(_toast.default, {
        removeToast: _this.props.removeToast,
        toastData: toast
      }));
    }).valueSeq());
  }
});

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ToastContainer);

exports.default = _default;
module.exports = exports.default;